import { SORT_DIRECTIONS, TABLE_GQL_SORT_DIRECTION_ENUM_MAP } from 'constants/sortDirectionsEnum';
import { ColumnData } from 'ui/tableHeader';
import { StyledTableHeader } from './UsersTable.styles';
import { useUsersTableContext } from '../../../contexts/usersTable';
import { useSegmentationQueryContext } from '../../../contexts/segmentationQuery';

export const UsersTableHeader = ({ columns }: { columns: ColumnData[] }) => {
  const { sortBy, setSortBy, sortDirection, setSortDirection } = useUsersTableContext();
  const { refreshQueryResults } = useSegmentationQueryContext();

  return (
    <StyledTableHeader
      sortedBy={sortBy}
      setSortedBy={(newSortBy: string) => {
        setSortBy(newSortBy);
        refreshQueryResults({ orderBy: newSortBy });
      }}
      sortDirection={sortDirection}
      setSortDirection={(newSortDirection) => {
        setSortDirection(newSortDirection as SORT_DIRECTIONS);
        refreshQueryResults({
          sorting: TABLE_GQL_SORT_DIRECTION_ENUM_MAP[newSortDirection as SORT_DIRECTIONS],
        });
      }}
      columns={columns}
    />
  );
};
